import React from "react";
import { Link } from "react-router-dom";
import {
    MarcarInventarioSinCambios,
    MarcarInventarioVacio,
} from "../../utils/AlmacenesTable";
import { ESTADOS_INV_ALMACEN } from "../../../../../../../../utility/constants";
import { ActionBtn } from "../../../../../../Utils/Buttons/ActionBtn";
const verIcon = require("assets/img/icons/ver.png");

const calculateIcon = require("assets/img/icons/calculate-icon.png");
const emptyIcon = require("assets/img/icons/empty-icon.png");
const repeatIcon = require("assets/img/icons/repeat-icon.png");

const undoIcon = require("assets/img/icons/undo.png");

export const ActionsCell = ({ item, estaCerrado, ActualizarEstadoAlmacen }) => {
    // El almacén de reproceso no se gestiona: su inventario sale de lo que
    // bodega le envió menos lo que las tancadas consumieron
    if (item.es_reproceso) {
        return <span>—</span>;
    }

    const showMainActions =
        item.estado === ESTADOS_INV_ALMACEN.PENDIENTE ||
        item.estado === ESTADOS_INV_ALMACEN.PENDIENTE_ANALISIS ||
        item.estado === ESTADOS_INV_ALMACEN.PROCESADO_SOBRANTE;

    if (showMainActions) {
        return (
            <div className="table-actions" style={{ gap: "10px" }}>
                <Link
                    to={`/inventarios-almacen/gestion-almacen/${item.inventario_almacen_id}`}
                >
                    {estaCerrado ? (
                        <img
                            src={verIcon}
                            alt="Ver"
                            className="action_img"
                            title="Ver"
                        />
                    ) : (
                        <ActionBtn
                            imgSource={calculateIcon}
                            title="Procesar sobrante"
                            btnColor="#035B2F"
                        />
                    )}
                </Link>
                {!estaCerrado && (
                    <React.Fragment>
                        <ActionBtn
                            imgSource={repeatIcon}
                            title="Utilizar mismo inventario"
                            btnColor="#999999"
                            onClick={() =>
                                MarcarInventarioSinCambios(
                                    item,
                                    ActualizarEstadoAlmacen,
                                )
                            }
                        />
                        <ActionBtn
                            imgSource={emptyIcon}
                            title="Marcar inventario final vacío"
                            btnColor="#FFC107"
                            onClick={() =>
                                MarcarInventarioVacio(
                                    item,
                                    ActualizarEstadoAlmacen,
                                )
                            }
                        />
                    </React.Fragment>
                )}
            </div>
        );
    } else {
        // Estados de inventario sin cambios o cero
        return !estaCerrado ? (
            <ActionBtn
                imgSource={undoIcon}
                title="Marcar como pendiente"
                btnColor="#0b4f9e"
                onClick={() =>
                    ActualizarEstadoAlmacen(
                        item.inventario_almacen_id,
                        ESTADOS_INV_ALMACEN.PENDIENTE,
                    )
                }
            />
        ) : (
            <span>—</span>
        );
    }
};
